module.exports = __webpack_public_path__ + "510dec37fa69fba39593e01a469ee018.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-500italic.woff2
// module id = 669
// module chunks = 0